import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const boolValidation = z
  .enum(["true", "false"])
  .default("false")
  .transform((data) => data === "true");

export const env = createEnv({
  server: {
    ROUTE_REVALIDATION_PASSKEY: z.string(),
    TURNSTILE_SECRET_KEY: z.string(),
    CONTACT_WEBHOOK_URL: z.string(),
    NEWSLETTER_WEBHOOK_URL: z.string(),
    CF_PAGES_URL: z.string(),
  },
  client: {
    NEXT_PUBLIC_COOKIESCRIPT_SOURCE: z.string(),
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string(),
  },
  shared: {
    NEXT_PUBLIC_BUILDER_API_KEY: z.string(),
    NEXT_PUBLIC_BUILDER_DISABLE_CACHE: boolValidation,
    NEXT_PUBLIC_BUILDER_INCLUDE_UNPUBLISHED: boolValidation,
  },
  // Next.js >= 13.4.4 dropped the static analysis of serverside environment variables, which means that the manual destruction is no longer necessary for serverside variables
  // https://env.t3.gg/docs/nextjs
  experimental__runtimeEnv: {
    NEXT_PUBLIC_BUILDER_API_KEY: process.env.NEXT_PUBLIC_BUILDER_API_KEY,
    NEXT_PUBLIC_COOKIESCRIPT_SOURCE: process.env.NEXT_PUBLIC_COOKIESCRIPT_SOURCE,
    NEXT_PUBLIC_BUILDER_DISABLE_CACHE: process.env.NEXT_PUBLIC_BUILDER_DISABLE_CACHE,
    NEXT_PUBLIC_BUILDER_INCLUDE_UNPUBLISHED: process.env.NEXT_PUBLIC_BUILDER_INCLUDE_UNPUBLISHED,
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
  },
});
